export interface ContactChannelSource {
    cellPhone?: string | null;
    phone1?: string | null;
    email1?: string | null;
    email1OptOut: boolean;
}

export interface PreferredEmail {
    address: string;
    optOut: boolean;
}

export function preferredPhone(
    bestContact: ContactChannelSource | null,
    selfContact: ContactChannelSource | null,
): string | null {
    return (
        bestContact?.cellPhone ||
        bestContact?.phone1 ||
        selfContact?.cellPhone ||
        selfContact?.phone1 ||
        null
    );
}

export function preferredEmail(
    bestContact: ContactChannelSource | null,
    selfContact: ContactChannelSource | null,
): PreferredEmail | null {
    if (bestContact?.email1) {
        return { address: bestContact.email1, optOut: bestContact.email1OptOut };
    }

    if (selfContact?.email1) {
        return { address: selfContact.email1, optOut: selfContact.email1OptOut };
    }

    return null;
}
